import React from 'react';
import styled from '@emotion/styled';

const ListItem = styled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;

const Icon = styled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #7ab800;
  }
`;

const Detail = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Country = styled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;

const CountryName = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

const validate = (countryName: string) => {
  return countryName && countryName !== '';
};

interface Props {
  countryName: string;
}

{
  /* Internationalise here */
  /* Revisit this as countryName and model may be wrong */
}
const CountryDetail = (props: Props) => {
  const { countryName } = props;
  return (
    <ListItem>
      <Icon viewBox='0 0 44 44'>
        <circle cx='22' cy='22' r='22' />
        <path d='M22.5 11c-5.8 0-11 4-11 9.56a8.64 8.64 0 0 0 1.87 5.37c.05 1.75-.94 4.26-1.82 6.08a25.6 25.6 0 0 0 7.3-2.42c8.46 2.15 14.62-3.25 14.62-9C33.49 15 28.27 11 22.5 11zm0 13.37H17v-1h5.5zM28 21.5H17v-1h11zm0-2.87H17v-1h11z' />
      </Icon>
      <Detail>
        {validate(countryName) && (
          <>
            <Country>Country</Country>
            <CountryName>{countryName}</CountryName>
          </>
        )}
      </Detail>
    </ListItem>
  );
};

export default CountryDetail;
